const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhyBuildSmallIconIi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 11.2,
    fill: "#181A1E",
    style: {
      fill: "#181A1E",
      fill: "color(display-p3 0.0941 0.1020 0.1176)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9951 33.4269C27.5811 33.4269 27.2451 33.0909 27.2451 32.6769V30.1399C27.2451 29.7259 27.5811 29.3899 27.9951 29.3899C28.4091 29.3899 28.7451 29.7259 28.7451 30.1399V32.6769C28.7451 33.0909 28.4091 33.4269 27.9951 33.4269Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5012_524",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 20,
    width: 20,
    height: 11
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0002 20.5802H37.99V30.8912H18.0002V20.5802Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5012_524)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5002 27.3932C21.8762 28.6842 24.8722 29.3912 27.9902 29.3912C31.1142 29.3912 34.1132 28.6842 36.4902 27.3932V24.3912C36.4902 23.1162 35.4592 22.0802 34.1902 22.0802H21.8102C20.5362 22.0802 19.5002 23.1122 19.5002 24.3812V27.3932ZM27.9902 30.8912C24.4452 30.8912 21.0282 30.0332 18.3712 28.4772C18.1412 28.3432 18.0002 28.0972 18.0002 27.8302V24.3812C18.0002 22.2852 19.7092 20.5802 21.8102 20.5802H34.1902C36.2862 20.5802 37.9902 22.2892 37.9902 24.3912V27.8302C37.9902 28.0972 37.8482 28.3432 37.6192 28.4772C34.9622 30.0332 31.5422 30.8912 27.9902 30.8912Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5012_524",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 18,
    width: 10,
    height: 5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7451 18.0004H32.2451V22.0763H23.7451V18.0004Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5012_524)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4951 22.0762C31.0811 22.0762 30.7451 21.7402 30.7451 21.3262V20.9602C30.7451 20.1552 30.0901 19.5002 29.2851 19.5002H26.7051C25.9001 19.5002 25.2451 20.1552 25.2451 20.9602V21.3262C25.2451 21.7402 24.9091 22.0762 24.4951 22.0762C24.0811 22.0762 23.7451 21.7402 23.7451 21.3262V20.9602C23.7451 19.3282 25.0731 18.0002 26.7051 18.0002H29.2851C30.9171 18.0002 32.2451 19.3282 32.2451 20.9602V21.3262C32.2451 21.7402 31.9091 22.0762 31.4951 22.0762Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.7949 37.7404H22.1949C20.1199 37.7404 18.3729 36.1194 18.2159 34.0494L18.0259 31.5404C17.9949 31.1274 18.3049 30.7664 18.7179 30.7354C19.1329 30.7204 19.4909 31.0134 19.5229 31.4274L19.7119 33.9354C19.8099 35.2274 20.8999 36.2404 22.1949 36.2404H33.7949C35.0899 36.2404 36.1809 35.2274 36.2779 33.9354L36.4679 31.4274C36.4999 31.0134 36.8669 30.7194 37.2729 30.7354C37.6859 30.7664 37.9949 31.1274 37.9639 31.5404L37.7739 34.0494C37.6169 36.1194 35.8699 37.7404 33.7949 37.7404Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyBuildSmallIconIi);
export default __webpack_public_path__ + "static/media/why-build-small-icon-ii.d13da25a3418cd8931cff6d1c9de47d8.svg";
export { ForwardRef as ReactComponent };